export default "__VITE_ASSET__C3wdg7bT__"